import React, { useState, useEffect,useRef } from 'react';
import axios from 'axios';
import { api_url } from "../config/config";

import DeletePrompt from "../Components/common/DeletePrompt";
function ManufacturerCard({ manufacturer, onEdit, onDelete }) {
    // if (!manufacturer || !manufacturer.manufacturer_id) {
    //     return <div>Invalid Manufacturer</div>;
    // }

    return (
        <div
            key={manufacturer.manufacturer_id}
            className="flex justify-between w-[calc(50%-0.5rem)] border rounded-lg p-2 py-4 border-green-700 bg-white"
            >
            <div className="flex items-center gap-4">
                {manufacturer.image_url ? (
                    <img
                        src={manufacturer.image_url}
                        alt={manufacturer.name}
                        className="w-20 h-10 object-cover rounded-md"
                    />
                ) : (
                    <div className="w-20 h-20 bg-gray-300 flex items-center justify-center rounded-md">
                        <span className="text-sm text-gray-600">No image</span>
                    </div>
                )}
                <div>
                    <h3 className="text-lg font-semibold text-gray-900">
                        {manufacturer.name}
                    </h3>
                </div>
            </div>
            <div className="flex gap-4 ml-auto">
                <button
                    onClick={() => onEdit(manufacturer)}
                    className="bg-blue-500 text-lg font-semibold text-white px-4 rounded-lg h-12"
                >
                    Edit
                </button>
                <button
                    onClick={() => onDelete(manufacturer.manufacturer_id)}
                    className="bg-red-500 text-white text-lg font-semibold px-4 rounded-lg h-12"
                >
                    Delete
                </button>
            </div>
        </div>



    );
}

function ManufacturerManagement() {
    const [manufacturers, setManufacturers] = useState([]);
    const [formData, setFormData] = useState({ manufacturer_name: '', image_file: null });
    const [editingManufacturerId, setEditingManufacturerId] = useState(null);
    const [error, setError] = useState(null);
    const [successMessage, setSuccessMessage] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
      const fileInputRef = useRef(null);

    // Fetch manufacturers
    const fetchManufacturers = (page) => {
        setIsLoading(true);
        axios
            .get(`${api_url}/manufacturer?page=${page}&limit=10`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: 'Bearer ' + localStorage.getItem('admin_token'),
                },
            })
            .then((response) => {
                if (response.data && response.data.results) {
                    setManufacturers(response.data.results);
                    setTotalPages(Math.ceil(response.data.total / 10));
                } else {
                    console.error('No manufacturers found in the response');
                }
            })
            .catch((err) => {
                console.error('Error fetching manufacturers:', err);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        fetchManufacturers(currentPage);
    }, [currentPage]);

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (name === 'image_file') {
            setFormData({ ...formData, [name]: files[0] });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    useEffect(() => {
        if (error || successMessage) {
            const timer = setTimeout(() => {
                setError(null);
                setSuccessMessage(null);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [error, successMessage]);

    const handleCreateManufacturer = () => {
        setError(null);
        setSuccessMessage(null);

        if (!formData.manufacturer_name) {
            setError('Manufacturer name is required');
            return;
        }

        if (formData.image_file && formData.image_file.size > 2 * 1024 * 1024) {
            setError('Image size should not exceed 2MB');
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('manufacturer_name', formData.manufacturer_name);
        if (formData.image_file) {
            formDataToSend.append('file', formData.image_file);
        }

        setIsLoading(true);
        axios
            .post(`${api_url}/manufacturer`, formDataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: 'Bearer ' + localStorage.getItem('admin_token'),
                },
            })
            .then((response) => {
                if (response.data.status === 'success') {
                    setManufacturers((prevManufacturers) => [
                        ...prevManufacturers,
                        response.data.data,
                    ]);
                    setFormData({ manufacturer_name: '', image_file: null });
                    if (fileInputRef.current) {
                        fileInputRef.current.value = ""; // Clear file input field
                    }
                    setSuccessMessage('Manufacturer created successfully!');
                } else {
                    setError('Failed to create manufacturer');
                }
            })
            .catch((err) => {
                setError(err.response?.data?.message || 'Error creating manufacturer');
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    const handleEditManufacturer = (manufacturer) => {
          setEditingManufacturerId(manufacturer.manufacturer_id);
          setFormData({ manufacturer_name: manufacturer.name, image_file: null });
      
          if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Clear file input field
          }
        
      };
      

    const handleUpdateManufacturer = () => {
        setError(null);
        setSuccessMessage(null);

        if (!formData.manufacturer_name) {
            setError('Manufacturer name is required');
            return;
        }

        const formDataToSend = new FormData();
        formDataToSend.append('manufacturer_name', formData.manufacturer_name);
        formDataToSend.append('manufacturer_id', editingManufacturerId);
        if (formData.image_file) {
            formDataToSend.append('file', formData.image_file);
        }

        setIsLoading(true);
        axios
            .patch(`${api_url}/manufacturer`, formDataToSend, {
                headers: {
                    "Content-Type": "multipart/form-data",
                    Authorization: 'Bearer ' + localStorage.getItem('admin_token'),
                },
            })
            .then((response) => {
                if (response.data.status === 'success') {
                    setManufacturers(
                        manufacturers.map((manufacturer) =>
                            manufacturer.manufacturer_id === editingManufacturerId
                                ? response.data.updatedManufacturer
                                // ? { ...manufacturer, ...response.data.updatedmanufacturer }
                                : manufacturer
                        )
                    );
                    setFormData({ manufacturer_name: '', image_file: null });
                    if (fileInputRef.current) {
                        fileInputRef.current.value = ""; // Clear file input field
                    }
                    setEditingManufacturerId(null);
                    setSuccessMessage('Manufacturer updated successfully!');
                } else {
                    setError('Failed to update manufacturer');
                }
            })
            .catch((err) => {
                setError(err.response?.data?.message || 'Error updating manufacturer');
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    // State for delete modal
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [manufacturerToDelete, setManufacturerToDelete] = useState(null);

    const handleDeleteManufacturer = (manufacturerId) => {
        setManufacturerToDelete(manufacturerId);
        setShowDeleteModal(true);
    };

    const handleConfirmDelete = () => {
        if (!manufacturerToDelete) return;
        setIsLoading(true);
        axios
            .delete(`${api_url}/manufacturer/${manufacturerToDelete}`, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: 'Bearer ' + localStorage.getItem('admin_token'),
                },
            })
            .then((response) => {
                if (response.data.status === 'success') {
                    setManufacturers(manufacturers.filter((m) => m.manufacturer_id !== manufacturerToDelete));
                    setSuccessMessage('Manufacturer deleted successfully!');
                } else {
                    setError('Failed to delete manufacturer');
                }
            })
            .catch((err) => {
                setError(err.response?.data?.message || 'Error deleting manufacturer');
            })
            .finally(() => {
                setIsLoading(false);
                setShowDeleteModal(false);
                setManufacturerToDelete(null);
            });
    };

    const handleCancelDelete = () => {
        setShowDeleteModal(false);
        setManufacturerToDelete(null);
    };


    return (
        <div className="p-10">
            <DeletePrompt
                showModal={showDeleteModal}
                onDelete={handleConfirmDelete}
                onCancel={handleCancelDelete}
            />
            <h2 className="text-2xl font-semibold mb-5">Manufacturer Management</h2>

            {error && <div className="bg-red-500 text-white p-2 mb-4 rounded">{error}</div>}
            {successMessage && <div className="bg-green-500 text-white p-2 mb-4 rounded">{successMessage}</div>}

            <div className="mb-5">
                <input
                    type="text"
                    name="manufacturer_name"
                    value={formData.manufacturer_name}
                    onChange={handleInputChange}
                    placeholder="Enter manufacturer name"
                    className="border border-gray-300 rounded-lg p-2 mr-2"
                />
                <input
                    type="file"
                    name="image_file"
                    ref={fileInputRef} 
                    onChange={handleInputChange}
                    className="border border-gray-300 rounded-lg p-2 mr-2"
                />
                {editingManufacturerId ? (
                    <button
                        onClick={handleUpdateManufacturer}
                        // disabled={isLoading}
                        className="bg-[#3C1F1F] text-white px-4 py-2 rounded-lg"
                    >
                        {isLoading ? 'Updating...' : 'Update Manufacturer'}
                    </button>
                ) : (
                    <button
                        onClick={handleCreateManufacturer}
                        // disabled={isLoading}
                        className="bg-[#3C1F1F] text-white px-4 py-2 rounded-lg"
                    >
                        {isLoading ? 'Creating...' : 'Create Manufacturer'}
                    </button>
                )}
            </div>

            <div className="flex flex-wrap gap-4">
  {manufacturers
    .filter((manufacturer) => manufacturer && manufacturer.manufacturer_id)
    .map((manufacturer) => (
      <ManufacturerCard
        key={manufacturer.manufacturer_id}
        manufacturer={manufacturer}
        onEdit={handleEditManufacturer}
        onDelete={handleDeleteManufacturer}
      />
    ))}
</div>





        </div>
    );
}

export default ManufacturerManagement;
